export default __webpack_public_path__ + "static/media/tipsarevic-quote-photo.0f988971.png";